import {
  getCountryData,
  getEmojiFlag,
  ICountryData,
  ILanguage,
  languages,
  TCountryCode,
  TLanguageCode,
} from 'countries-list';

export type LocaleInfo = {
  locale: string;
  language: ILanguage;
  country?: ICountryData;
  countryEmoji?: string;
  countryFlag?: string;
};

const LOCALE_REGEX = /^(?<language>[A-Za-z]+)(-(?<country>[A-Za-z]+))?$/;

export function getLocaleInfo(locale: string): LocaleInfo | null {
  const match = locale.match(LOCALE_REGEX);
  const languageCode = match?.groups?.language as TLanguageCode | undefined;
  const countryCode = match?.groups?.country as TCountryCode | undefined;

  const country = countryCode && getCountryData(countryCode);
  const language = languageCode && languages[languageCode];

  const location = locale.length >= 5 ? locale.slice(3).toLowerCase() : null;

  // Flags are sourced from: https://flagicons.lipis.dev/ in the flags/1x1 folder
  // If more are required

  const countryFlag = countryCode ? `/assets/flags/${location}.svg` : '';

  return language
    ? {
        locale,
        country,
        language,
        countryFlag,
        countryEmoji: countryCode && getEmojiFlag(countryCode),
      }
    : null;
}
